import { SELECT_SHIPPING, GET_SHIPPING, GENERATE_RETURN_WAYBILL, SAVE_SHIPPING, CHANGE_SHIPPING_CARRIER, DELETE_SHIPPING, CLEAR_SHIPPING, SET_SEARCHING, LOGOUT_USER, API_ERROR} from '../constants/ActionTypes'
import Popup from 'react-popup'
import intl from 'react-intl-universal'
import Odoo from '../utils/Odoo'

function api_error(dispatch, e){
  if (e && e.status === 403){
    Popup.alert(intl.get('Sesja wygasła'))
    dispatch({
      type: LOGOUT_USER
    })
  } else {
    dispatch({
      type: API_ERROR,
      message: e.message
    })
  }
}

export function selectShipping(shipping) {
  return dispatch => {
    dispatch({
      type: SELECT_SHIPPING,
      payload: shipping
    })
    if(shipping === false){
      dispatch({
        type: GET_SHIPPING,
        payload: false
      })
    }
  }
}

export function deleteShipping(shipping_id) {
  return dispatch => {
    Odoo.call('packing_zone/delete_shipping', {shipping_id}).then(res => {
      Popup.close()
      dispatch({
        type: DELETE_SHIPPING,
        payload: shipping_id
      })
    }).catch(error => {
      Popup.clearQueue()
      Popup.close()
      api_error(dispatch, error)
    })
  }
}


export function generateReturnWaybill(shipping_id) {
    return dispatch => {
      Odoo.call('packing_zone/generate_return_shipping_order', {shipping_id}).then(res => {
        Popup.close()
        dispatch({
          type: GENERATE_RETURN_WAYBILL,
          payload: shipping_id
        })
      }).catch(error => {
        Popup.clearQueue()
        Popup.close()
        api_error(dispatch, error)
      })
    }
  }

export function getShipping(shipping_id, order_id) {
  let params = {
    shipping_id,
    order_id
  }
  return dispatch => {
    dispatch({
      type: SET_SEARCHING,
      payload: true
    })
    return Odoo.call('packing_zone/get_shipping_data', params).then(res => {
      if(!res.id){
        res.shipping_parcels_ids = res.shipping_parcels_ids.map(p => p[2])
      }
      dispatch({
        type: GET_SHIPPING,
        payload: res
      })
      return res
    }).catch(error => {
      api_error(dispatch, error)
      throw error
    }).finally(() => {
      dispatch({
        type: SET_SEARCHING,
        payload: false
      })
    })
  }
}

export function clearShippingData(){
  return dispatch => {
    dispatch({
      type: CLEAR_SHIPPING
    })
  }
}

export function saveShipping(id, data, order_id) {
  let params = data
  if(id){
    params.id = id
  }
  if(order_id){
    params.sale_order_id = order_id
  }

  return dispatch => {
    return Odoo.call('packing_zone/save_shipping_data', params).then(res => {
      dispatch({
        type: SAVE_SHIPPING,
        payload: res
      })
      return res
    }).catch(error => {
      api_error(dispatch, error)
      throw error
    })
  }
}

export function changeShippingCarrier(id, rate, order_id) {
  const params = { ...(rate.extra_vals || {}), id, carrier_id: rate.carrier_id }
  if(order_id){
    params.sale_order_id = order_id
  }

  return dispatch => {
    return Odoo.call('packing_zone/save_shipping_data', params).then(res => {
      dispatch({
        type: CHANGE_SHIPPING_CARRIER,
        payload: { id, carrier_id: rate.carrier_id, carrier: rate.carrier_name }
      })
      dispatch({
        type: SAVE_SHIPPING,
        payload: res
      })
      return res
    }).catch(error => {
      api_error(dispatch, error)
      throw error
    })
  }
}

const sanitizeShippingData = (data) => {
  const exclude = ['sizes', 'types', 'carriers', 'shops', 'countries', 'currency_id'];
  const sanitized = {};

  Object.keys(data).forEach(key => {
    if (!exclude.includes(key)) {
      sanitized[key] = data[key];
    }
  });

  if (typeof sanitized.receiver_country === 'string' && Array.isArray(data.countries)) {
    const match = data.countries.find(c => c[1] === sanitized.receiver_country);
    if (match) {
      sanitized.receiver_country = match[0];
    }
  }

  return sanitized;
}



export function getTransitRate(shipping_id, data, order_id) {
  const params = shipping_id
    ? { shipping_id }
    : { ...sanitizeShippingData(data), sale_order_id: order_id }

  return dispatch => {
    return Odoo.call('packing_zone/get_transit_rate', params).catch(error => {
      if (error && error.status === 403) {
        api_error(dispatch, error)
      }
      throw error
    })
  }
}

export function createNewShipping(order_id) {
  return async (dispatch) => {
    try {
      const shippingData = await dispatch(getShipping(0, order_id));
      const paramsToSave = sanitizeShippingData({ ...shippingData, id: 0 });
      await dispatch(saveShipping(0, paramsToSave, order_id));
    } catch (error) {
      api_error(dispatch, error);
    }
  };
}
